const { default: jsonLdOrganization } = require('./organization');
const { host } = require('./utils');

const jsonLdContactPage = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  mainEntityOfPage: {
    '@type': 'WebPage',
    '@id': `${host}/contact`,
  },
  publisher: jsonLdOrganization,
};

export default jsonLdContactPage;
